import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

type Props = {
  icon: LucideIcon;
  title: string;
  children: ReactNode;
  className?: string;
};

export const CustomPolicySectionCard = ({ icon: Icon, title, children, className }: Props) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 rounded-lg border border-gray-200 bg-[#F1F5F9] p-6 shadow-xs",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <Icon className="text-brand700 size-5" />
        <span className="text-lg font-semibold text-black">{title}</span>
      </div>
      {children}
    </div>
  );
};
